import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from 'vue-router/composables'
import ArrowLeft from '@/assets/icons/ArrowLeft.vue'
import MyTicketsInterface from '@/features/tickets/ui/MyTicketsInterface.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyTicketsPage',
  setup(__props) {

const route = useRoute()

return { __sfc: true,route, ArrowLeft, MyTicketsInterface }
}

})